import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

const state = {
    briefId: 0,
    isMuestra: false,

    id: 0,
    descripcion: '',
    link: '',
    usuarioId: 0,
    usuario: '',
    isValidado: false,
    rowVersion: null,

    isDirty: false
};

const mutations = {
    // updateField,

    updateField(state, field) {
        updateField(state, field);

        state.isDirty = true;
        // console.log(field);
    },

    'INICIALIZAR_ENTREGA'(state, params) {
        state.briefId = params.briefId;
        state.isMuestra = params.isMuestra;

        state.id = params.briefMuestraId;
        state.descripcion = '';
        state.link = '';
        state.usuarioId = params.usuarioId;
        state.usuario = params.usuario;
        state.isValidado = false;
        state.rowVersion = null;

        state.isDirty = false;
    },
    'SET_ENTREGA'(state, briefOriginal) {
        state.briefId = params.briefId;

        state.id = params.briefOriginalId;
        state.descripcion = briefOriginal.trim();
        state.link = briefOriginal.link.trim();
        // state.validado = false;
        state.rowVersion = briefOriginal.rowVersion;
    },
    'SET_ENTREGA_ID' (state, entregaId) {
        state.id = entregaId;
    },

    'SET_CLEAN'(state) {
        state.isDirty = false;
    },
    'SET_DIRTY'(state) {
        state.isDirty = true;
    },
};

const getters = {
    getField,

    dirty(state) {
        if ((/true/i).test(state.isDirty)) {
            return true;
        }

        return false;
    },

    briefEntrega(state) {
        return {
            id: state.id,
            link: state.link,
            descripcion: state.descripcion,
            usuarioId: state.usuarioId,
            usuario: state.usuario,
            rowVersion: state.rowVersion,

            /* Originales */
            isValidado: state.isValidado
        }
    }    
};

const actions = {
    inicializarMuestra ( { rootState, commit }, params ) {
        return new Promise((resolve, reject) => {
            params.isMuestra = true;

            if (rootState.user) {
                if (rootState.user.userId) {
                    params.usuarioId = rootState.user.userId;
                }
                if (rootState.user.nombreCompleto) {
                    params.usuario = rootState.user.nombreCompleto.trim();
                }
            }

            commit('INICIALIZAR_ENTREGA', params);

            let getEntrega = false;

            if (params.briefMuestraId) {
                getEntrega = params.briefMuestraId != 0;
            }

            if (getEntrega) {
                apiAxios.get(`briefs/${params.briefId}/muestras/${params.briefMuestraId}`)
                .then(res => {
                    commit('SET_ENTREGA', res.data);
                    resolve();
                })
                .catch(error => reject(error))
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },    
    inicializarOriginal ( { rootState, commit }, params ) {
        return new Promise((resolve, reject) => {
            params.isMuestra = false;

            if (rootState.user) {
                if (rootState.user.userId) {
                    params.usuarioId = rootState.user.userId;
                }
                if (rootState.user.nombreCompleto) {
                    params.usuario = rootState.user.nombreCompleto.trim();
                }
            }

            commit('INICIALIZAR_ENTREGA', params);

            let getEntrega = false;

            if (params.briefOriginalId) {
                getEntrega = params.briefOriginalId != 0;
            }

            if (getEntrega) {
                apiAxios.get(`briefs/${params.briefId}/originales/${params.briefOriginalId}`)
                .then(res => {
                    commit('SET_ENTREGA', res.data);
                    resolve();
                })
                .catch(error => reject(error))
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },    
    // save ( { state, commit } ) {
    //     return new Promise((resolve, reject) => {
    //         let save = true;
    //         let errorMessage = '';

    //         let isValidado = false;
    //         if (!(/true/i).test(state.isMuestra)) {
    //             isValidado = (/true/i).test(state.validado);
    //         }

    //         if (save) {
    //             let briefEntrega = {
    //                 descripcion: state.descripcion.trim(),
    //                 link: state.link.trim(),
    //                 validado: isValidado
    //             }
                
    //             let url = `briefs/${state.briefId}/muestras`;
    //             if (!(/true/i).test(state.isMuestra)) {
    //                 url = `briefs/${state.briefId}/originales`;
    //             }

    //             if (state.id) {
    //                 if (state.id != 0) {
    //                     url += `/${state.id}`;
    //                     briefEntrega.rowVersion = state.rowVersion;
    //                 }
    //             }

    //             apiAxios.post(url, briefEntrega)
    //                 .then(res => {
    //                     commit('SET_ENTREGA_ID', res.data.id);
    //                     resolve()
    //                 })
    //                 .catch(error => reject(helpers.methods.getErrorMessage(error)));
    //         } else {
    //             reject(new Error(errorMessage));
    //         }
    //     })
    // },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}